import { render } from "./BlogPhoto2.vue?vue&type=template&id=e8564812&scoped=true"
import script from "./BlogPhoto2.vue?vue&type=script&lang=js"
export * from "./BlogPhoto2.vue?vue&type=script&lang=js"

import "./BlogPhoto2.vue?vue&type=style&index=0&id=e8564812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8564812"]])

export default __exports__